import React, { useState, useRef, useEffect } from "react";

// Components
import { convertToRaw, ContentState, EditorState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

import "./TextEditor.sass";

const TextEditor = props => {
    const [isInit, setIsInit] = useState(false);
    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const { placeholder = "Start typing", disableFontSize } = props

    const initialize = () => {
        if (isInit) return;

        if (props.initialValue) {
            const contentBlock = htmlToDraft(props.initialValue);
            if (contentBlock) {
                const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
                setEditorState(EditorState.createWithContent(contentState));
            }
        }

        setIsInit(true);
    };

    const componentIsMounted = useRef(true)
    useEffect(() => {
        return () => {
            componentIsMounted.current = false
        }
    }, [])

    const onEditorStateChange = editorState => {
        setEditorState(editorState)

        const htmlContent = draftToHtml(convertToRaw(editorState.getCurrentContent()));
        return props.onChange(htmlContent);
    };

    initialize()


    let toolbar = {
        options: ['inline', 'colorPicker', 'fontSize', 'fontFamily'],
        inline: {
            options: ['bold', 'italic']
        },
        fontFamily: {
            options: ['Arial', 'Georgia', 'Impact', 'Tahoma', 'Times New Roman', 'Verdana', 'Nunito', 'Dancing Script'],
        }, 
        colorPicker: {
            popupClassName: 'color-picker-modal'
        },
    
    }

    if (disableFontSize) {
       toolbar.options = ['inline', 'colorPicker', 'fontFamily']
    }

    return (
        <>
            <div className="editor">
                <Editor
                    editorState={editorState}
                    onEditorStateChange={onEditorStateChange}
                    wrapperClassName="wrapper-class"
                    editorClassName="editor-class"
                    toolbarClassName="toolbar-class"
                    placeholder={placeholder}
                    toolbar={toolbar}
                />
            </div>
        </>
    );
};

export default TextEditor;
